export const LoadingAI = () => {
  return (
    <div className="flex items-center justify-center">
      <video
        autoPlay
        loop
        muted
        preload="auto"
        className="w-full h-auto"
      >
        <source
          src="https://storage.googleapis.com/demostack_static_prod/demostack-image%20/LoadingAI.mp4"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};
